import styled from 'styled-components';

export const ConnectionSelectorContainer = styled.div`
  .connection-selector-button {
    width: 100%;
  }
`;
